import './App.css';
import BusinessCard from './BusinessCard';
import {Route, Routes} from 'react-router-dom';
import React from 'react'

function App() {
    return (

        <div className="App">
            <header className="App-header">
                <Routes>
                    <Route path="/" element={<BusinessCard />} />
                    <Route path="/:id" element={<BusinessCard />} />
                    <Route path="/user/:id" element={<BusinessCard />} />
                </Routes>
            </header>
        </div>
    );
}

export default App;
